import styled from "styled-components";

export const SlaCommsWrapper = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Primary,
    margin: `${theme.spacing.empty} ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium}`,
    padding: theme.spacing.xxSmall,
    borderRadius: theme.cornerRadius.small,
}));
